import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Container, Button, Stack } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { articles } from '../data/articles';

const NewsDetailPage: React.FC = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Header />
        <Container sx={{ py: 8 }}>
          <Typography variant="h5" align="center" color="error">
            Article not found.
          </Typography>
        </Container>
        <Footer />
      </>
    );
  }

  // Split article content into paragraphs
  const paragraphs = (article.content ?? article.description ?? '')
    .split('\n')
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <>
      <Header />

      {/* 90% width, curved, centered image */}
      <Box
        component="img"
        src={article.image}
        alt={article.title}
        sx={{
          width: '95vw',
          maxWidth: '95vw',
          height: { xs: 200, sm: 320, md: 400 },
          objectFit: 'cover',
          display: 'block',
          borderRadius: 1,      // Nice, smooth corners!
          mb: { xs: 4, md: 6 },
          mx: 'auto',            // Center the image
          boxShadow: 3,          // Optional: gives it a soft shadow
        }}
      />

      <Box sx={{ backgroundColor: '#f9f9f9', py: 10 }}>
        <Container maxWidth="md">
          <Typography
            variant="h4"
            fontWeight={700}
            mb={2}
            fontFamily={"'Playfair Display', Georgia, serif"}
          >
            {article.title}
          </Typography>
          {/* Author, Date */}
          <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
            {article.author && (
              <Typography
                variant="subtitle2"
                color="text"
                fontFamily={'"Segoe UI", "Helvetica Neue", Arial, sans-serif'}
              >
                By {article.author}
              </Typography>
            )}
            <Typography
              variant="subtitle2"
              color="text"
              fontFamily={'"Segoe UI", "Helvetica Neue", Arial, sans-serif'}
            >
              {article.date}
            </Typography>
          </Stack>
          {/* Paragraphs */}
          {paragraphs.map((p, i) => (
            <Typography
              key={i}
              variant="body1"
              sx={{ mb: 3 }}
              fontFamily={'"Segoe UI", "Helvetica Neue", Arial, sans-serif'}
            >
              {p}
            </Typography>
          ))}

          <Button
            variant="contained"
            sx={{
              backgroundColor: '#065187',
              '&:hover': { backgroundColor: '#0A6FB3' }
            }}
            onClick={() => {
    window.location.href = '/#insights';
  }} 
          >
            Back to Homepage
          </Button>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default NewsDetailPage;
